import React, {useEffect} from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CssBaseline from "@material-ui/core/CssBaseline";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DoneAllIcon from '@material-ui/icons/DoneAll';
import { Typography, Button } from '@mui/material';
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from 'react-router-dom';
import wallPaper from "../assets/static/images/kea-academia.jpeg";
import { BRAND_NAME } from "../shared/consts";
import { academicsIntro, curricula, academicStrengths } from "./configs/AcademicsData";

const useStyles = makeStyles((theme) => ({
  heroContent: {
    padding: theme.spacing(14, 0, 6),
    backgroundImage: `url(${wallPaper})`,
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
    backgroundBlendMode: 'darken',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  sectionTitle: {
    paddingBottom: '30px',
    fontWeight: 'bolder',
    paddingTop: '64px',
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 6px 2px 0 rgba(0,0,0,0.008)',
    border: '1px solid #E2EAF7',
    borderRadius: '16px'
  }
}));

export default function Academics() {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <meta name="description"
              content="Cambridge and ZIMSEC subjects offered at King Edwards Academy" />
        <title>{BRAND_NAME} - Academics</title>
      </Helmet>
      <CssBaseline />
      <main>
        <div className={classes.heroContent}>
          <Breadcrumb>
            <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
            <BreadcrumbItem active>Academics</BreadcrumbItem>
          </Breadcrumb>
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h4"
              align="center"
              color="textPrimary"
              style={{fontWeight: 'bold'}}
              gutterBottom>
              <span style={{backgroundColor: 'rgb(245, 195, 0)', padding: '0.0em 0.2em 0.0em 0.2em'}}>
                Academics
              </span>
            </Typography>
          </Container>
        </div>
      </main>

      <Container maxWidth="md">
        <Typography
          component="h2"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitle}
          gutterBottom>
          Subjects We Offer
        </Typography>
        <Typography align="center" style={{color: '#686868', marginBottom: '40px'}}>
          {academicsIntro}
        </Typography>

        <Grid container spacing={4}>
          {curricula.map((curriculum) => (
            <Grid item key={curriculum.id} xs={12} md={6}>
              <Card className={classes.card} elevation={0}>
                <CardContent>
                  <Typography
                    variant="h6"
                    component="h3"
                    align="center"
                    style={{fontWeight: 'bold'}}>
                    {curriculum.name}
                  </Typography>
                  <Typography align="center" style={{color: '#686868', fontSize: '0.9rem'}}>
                    {curriculum.levels}
                  </Typography>
                  <Divider variant="middle" style={{marginBottom: '15px', marginTop: '15px'}} />
                  <List dense>
                    {curriculum.subjects.map((subject) => (
                      <ListItem key={subject}>
                        <ListItemIcon style={{minWidth: '36px'}}>
                          <DoneAllIcon style={{color: 'rgb(245, 195, 0)'}} />
                        </ListItemIcon>
                        <ListItemText primary={subject} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography
          component="h2"
          variant="h5"
          align="center"
          color="textPrimary"
          className={classes.sectionTitle}
          gutterBottom>
          Our Academic Strengths
        </Typography>

        <Grid container spacing={4}>
          {academicStrengths.map((strength) => (
            <Grid item key={strength.id} xs={12} sm={6}>
              <Card className={classes.card} elevation={0}>
                <CardContent>
                  <Typography variant="h6" component="h3" style={{fontWeight: 'bold'}}>
                    {strength.title}
                  </Typography>
                  <Divider variant="fullWidth" style={{marginBottom: '15px', marginTop: '15px'}} />
                  <Typography style={{color: '#686868'}}>
                    {strength.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <div style={{textAlign: 'center', marginTop: '48px', marginBottom: '64px'}}>
          <Button
            variant="contained"
            color="secondary"
            disableElevation
            onClick={() => history.push('/apply')}>
            Apply Now
          </Button>
        </div>
      </Container>
    </React.Fragment>
  );
}
